import { Record } from 'immutable';

const TotalScoreRecord = Record({
  isEmpty: undefined,
  isNotApplicable: undefined,
  percentage: undefined,
  skillScorePercentages: new Map(),
});

class TotalScore extends TotalScoreRecord { }

TotalScore.create = (data) =>
  new TotalScore(data);

export default TotalScore;



// WEBPACK FOOTER //
// ./data/ProgressTests/StudentProgressTestResults/TotalScore/model.js